// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Fn-z","breadcrumbItem":"Gn-z","hideOnMobile":"Hn-z"};